const baseStyle = {
  th: {
    fontSize: 14,
    fontWeight: 500,
    color: 'darkBlue.main',
  },
}

const defaultProps = {
  size: 'lg',
  variant: 'bordered',
}

const parts = ['container', 'sortIcon', 'tbody', 'td', 'tfoot', 'th', 'thead', 'tr']

const sizes = {
  lg: {
    tr: {
      h: 48,
    },
  },
  md: {
    tr: {
      h: 40,
    },
  },
  sm: {
    tr: {
      h: 32,
    },
  },
}

const variants = {
  bordered: {
    td: {
      borderBottom: '1px solid sandstone.90',
    },
  },
  striped: {},
  basic: {
    td: {
      borderBottom: '1px solid sandstone.90',
    },
  },
}

export default {
  baseStyle,
  defaultProps,
  parts,
  sizes,
  variants,
}
